import { AddsUpSection } from '@/components/how-it-works/AddsUpSection'
import { HowItWorksHero } from '@/components/how-it-works/HowItWorksHero'
import { MethodSection } from '@/components/how-it-works/MethodSection'
import { PartsSection } from '@/components/how-it-works/PartsSection'
import { InviteSection } from '@/components/sections/InviteSection'
import { useSectionPaging } from '@/components/motion/useSectionPaging'
import { PageSeo } from '@/components/seo/PageSeo'
import { sitePages } from '@/config/pages'

/** The screens magnetic scroll stops at: the two parts, the transformation's heading and each of its steps, how it adds up, and the invitation. */
const howItWorksScreens = '.w-snap, .w-method .w-head, .w-step, .x-invite'

export const HowItWorksPage = () => {
  useSectionPaging(howItWorksScreens)

  return (
    <>
      <PageSeo page={sitePages.howItWorks} />
      <HowItWorksHero />
      <PartsSection />
      <MethodSection />
      <AddsUpSection />
      <InviteSection
        id="w-next"
        titleId="w-next-title"
        className="w-next"
        eyebrow="Next step"
        title="Let’s start by getting to know each other"
        lead="The first call goes both ways. We learn how your firm works today, what you want it to become and we explain United in more detail. If we both see a fit, you meet the team building Justine and see how it would apply to your firm’s own work."
      />
    </>
  )
}
